import { TranslationKeys } from '.';


export const lang: Record<TranslationKeys, string> = {
    show: 'Show',
    hide: 'Hide',
    'content-for': 'content for',
    'submenu-for': 'submenu for',
    'follow-us-on': 'Follow us on',
    'written-by': 'Written by',
    'all': 'All',
    'load-more': 'Load more',
    'filter-on': 'Filter on',
    'minute-read': ' minute read',
    'form-sent': 'Form sent successfully',
    'form-error': 'Something went wrong, please try again',
    'captcha-required': 'Please confirm you are human',
    'captcha-failed': 'Verification failed, please try again',
    'captcha-unavailable': 'The verification check could not load. Please disable any ad blocker for this page and reload.',
    'accept-terms': 'You must accept the terms and conditions',
    'first-name-invalid': 'First name is invalid',
    'last-name-invalid': 'Last name is invalid',
    'email-invalid': 'Email is invalid',
    'zip-code-invalid': 'Zip code is invalid',
    'phone-invalid': 'Phone number is invalid',
    'is-required': 'is required',
    'see-our-projects': 'See our projects',
    'news': 'News',
    'press': 'Press',
    'close-menu': 'Close menu',
    'find-something-good': 'Find something good!',
    'search-hint': 'Search here...',
    'found': 'Found',
    'hits': 'hits',
    'go-to-homepage': 'Go to homepage',
    'twofour-blog-name': 'TwoFour Blog',
    'twofour-blog-url': 'https://www.twofour.com/blog',
    'search': 'Search',
    'show-menu': 'Show menu',
    'open-search': 'Open search',
    'copy-code-to-clipboard': 'Copy code to clipboard',
    'twofour-slogan': '',
    'post-type-page': 'Page',
    'post-type-news': 'News',
    'post-type-blog': 'Blog',
    'post-type-project': 'Project',
    'post-type-client': 'Client',
    'code-copied-to-clipboard': 'Code copied to clipboard!',
    'read-more': 'Read more',
    'primary-navigation': 'Primary navigation',
    'secondary-navigation': 'Secondary navigation',
    'no-results': 'No results',
};